import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressModel } from 'src/app/core/models/address.model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { GlobalComponent } from 'src/app/global-component';
import { Component, Input } from '@angular/core';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { Subscription } from 'rxjs';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { DomSanitizer } from '@angular/platform-browser';
import { ClientSignatureModel } from 'src/app/core/models/members/client/client-signature.model';
import { SignatureModalService } from '../signature-request/signature-modal.service';
import { ClientSignatureRequestModel } from 'src/app/core/models/members/client/client-signature-request.model';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { BaseModalWithProfilePhotoComponent } from '../base-modal-with-profile-photo/base-modal-with-profile-photo.component';
import { EntityFileModel } from 'src/app/core/models/file/entity-file-model';
import { OwnerEntityType } from 'src/app/core/enums/owner-entity-type-enum';
import Swal from 'sweetalert2';
import { AccountStatus } from 'src/app/core/models/members/user/user.model';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';
import { ClientRequisitionListConfig } from '../../list-views/client-list/configs/client-requisition-list.config';
import { Roles } from 'src/app/core/security/roles';


@Component({
  selector: 'app-client-modal',
  templateUrl: './client-modal.component.html',
  styleUrls: ['./client-modal.component.scss']
})
export class ClientModalComponent extends BaseModalWithProfilePhotoComponent {

  emailPattern = GlobalComponent.emailPattern;
  datePattern = GlobalComponent.datePattern;

  maritalList = GlobalComponent.maritalList;
  genderList = GlobalComponent.genderList;

  statusList = [
    new NgSelectListModel(AccountStatus.Approved, $localize`:@@:Approved`, $localize`:@@:Approved`),
    new NgSelectListModel(AccountStatus.Disabled, $localize`:@@:Disabled`, $localize`:@@:Disabled`),
    new NgSelectListModel(AccountStatus.Onboarding, $localize`:@@:Onboarding`, $localize`:@@:Onboarding`),
    new NgSelectListModel(AccountStatus.PasswordReset, $localize`:@@:Password Reset`, $localize`:@@:Password Reset`),
    new NgSelectListModel(AccountStatus.Pending, $localize`:@@:Pending`, $localize`:@@:Pending`),
  ]

  loginType?: LoginType = this.authMyFileService.currentUserContextValue?.loginType;

  securityPermissionClientCreate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientCreate);
  securityPermissionClientDelete: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientDelete);
  securityPermissionClientUpdate: boolean = this.authMyFileService.canAccessOperation(SecurityOperations.client.clientUpdate);
  securityRoleIsAdmin: boolean = this.authMyFileService.isInRole(Roles.admin);
  //used for TimeLines Enum
  OwnerEntityType = OwnerEntityType;

  //enums for Html
  LoginType = LoginType;

  @Input() public override model: ClientSignatureModel = new ClientModel;
  @Input() public entityTypeId: EntityTypeEnum = EntityTypeEnum.Client;
  @Input() public disableInputs: boolean = false;

  //Password Reset Boolean variables used for Error Messages and Validation
  clientOldPassword?: string = undefined;
  clientNewPassword?: string = undefined;
  clientConfirmPassword?: string = undefined;
  clientPasswordEdited: boolean = false;
  clientOldPasswordInvalid: boolean = false;
  oldPasswordFieldType: boolean = false;
  newPasswordFieldType: boolean = false;
  confirmPasswordFieldType: boolean = false;

  adminNewPassword?: string = undefined;
  adminPasswordEdited: boolean = false;
  adminPasswordFieldType: boolean = false;

  //Used in Sin Validation on HTML
  invalidSin: boolean = false;

  tableConfig = new ClientRequisitionListConfig();
  constructor(
    protected clientSignatureModalService: SignatureModalService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  ngOnInit(): void {
    if (this.loginType === LoginType.Client) {
      this.securityPermissionClientUpdate = true;
    }
    if (this.model.id === undefined) {
      this.newModel = true;
    } else {
      this.loadProfilePhoto(this.model.id, this.entityTypeId, this.model.profilePhotoFileId, this.model.fullName);
    }
  }

  ngOnDestroy(): void {
    this.model = new ClientModel;
  }

  //this allows for us to update without having the date values change on the modal, after submit button is pressed since those values are two way binded to this.model
  preserveVisualModel(): ClientSignatureModel {

    var newClientModel: ClientSignatureModel = { ...new ClientModel(), ...this.model };

    newClientModel.dateOfBirth = GlobalComponent.dateTransform(newClientModel.dateOfBirth, true);
    newClientModel.dateOfLoss = GlobalComponent.dateTransform(newClientModel.dateOfLoss, true);

    return newClientModel;
  }

  onUpdate(): void {
    this.disableEditing = true;

    this.myFileApiService.updateClient(this.preserveVisualModel()).subscribe(
      (result: boolean | undefined) => {
        if (result) {
          this.toasterNotificationService.showSuccess($localize`:@@ClientPopUp_Toast_Success_UpdateClient:Your client has been updated.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
        this.submitted = false;
        this.disableEditing = false;
        this.close();
      }
    )
  }

  onCreate(): void {
    this.disableEditing = true;

    this.myFileApiService.precreateClient().subscribe(
      (newClient: ClientModel | undefined) => {
        if (newClient) {
          newClient.address = this.model.address;
          newClient.insuranceCompany = this.model.insuranceCompany;
          newClient.opposingCounsel = this.model.opposingCounsel;

          newClient.dateOfBirth = this.preserveVisualModel().dateOfBirth;
          newClient.dateOfLoss = this.preserveVisualModel().dateOfLoss;

          newClient.userName = this.model.email;

          if (this.model.fileUpload.entityFiles != undefined) {
            this.model.fileUpload.entityFiles.forEach((file: EntityFileModel) => {
              if (file.id) {
                newClient?.fileUpload.fileIdsToAdd.push(file.id);
              }
            })
          }
          //added this to make sure that any clients created by a Witness are by default approved. This is only for clients NOT invited to myfle and created by the witness. 
          newClient.status = AccountStatus.Approved;

          newClient = { ...this.model, ...newClient };
          newClient = newClient;

          this.myFileApiService.createClient(newClient).subscribe(
            (result: ClientModel | undefined) => {
              if (result) {

                //this is needed here for the model to be picked up by the dropdown list option on create. 
                this.model = result;

                this.toasterNotificationService.showSuccess($localize`:@@ClientPopUp_Toast_Success_CreateClient:Your new client has been created.`, $localize`:@@Toast_Success_GeneralTitle:Success`);
              }
              this.submitted = false;
              this.disableEditing = false;
              this.close();
            }
          )

        } else {
          this.submitted = false;
          this.disableEditing = false;
        }
      });
  }

  validate() {
    if (
      this.model.email != undefined && this.model.email != '' && (this.model.email.match(this.emailPattern) != null)
      && this.model.name != undefined && this.model.name != ''
      && this.model.lastName != undefined && this.model.lastName != ''
      && this.model.dateOfBirth != undefined && this.model.dateOfBirth != '' && this.datePattern.test(this.model.dateOfBirth)
      && this.model.gender != undefined && this.model.gender != ''
      && this.model.maritalStatus != undefined && this.model.maritalStatus != ''
      && this.model.dateOfLoss != undefined && this.model.dateOfLoss.length == 10 && this.datePattern.test(this.model.dateOfLoss)
      && (
        (this.model.phoneNumber != undefined && this.model.phoneNumber.length == 14)
        || (this.model.phoneNumber == undefined) || (this.model.phoneNumber == '')
      )
    ) {
      if (AddressModel.validateAddressModel(this.model.address)) {
        return true;
      } else {
        this.activeTab = 2
      }
    } else {
      this.activeTab = 1
    }
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false;
  }

  requestSignature() {
    var clientSigRequest: ClientSignatureRequestModel = new ClientSignatureRequestModel;

    clientSigRequest.clientId = this.model.id;
    clientSigRequest.email = this.model.email;

    this.clientSignatureModalService.openModal(clientSigRequest, this.model.fullName);
    var sub: Subscription = this.clientSignatureModalService.modelChanged.subscribe((result: any) => {
      if (result) {
        this.toasterNotificationService.showSuccess($localize`:@@:A signature request was emailed to your client`, $localize`:@@Toast_Success_GeneralTitle:Success`);
      }
      sub.unsubscribe();
    })
  }

  updatePassword() {
    this.modalEdited = true;
    this.clientPasswordEdited = true
    if (
      (this.clientNewPassword != undefined && this.clientNewPassword != "")
      || (this.clientOldPassword != undefined && this.clientOldPassword != "")
      || (this.clientConfirmPassword != undefined && this.clientConfirmPassword != "")
    ) {
      this.clientOldPasswordInvalid = true;
      if (this.clientOldPassword == this.model.password) {
        this.clientOldPasswordInvalid = false;
        if (this.clientNewPassword != undefined && this.clientNewPassword.length > 5 && this.clientNewPassword == this.clientConfirmPassword) {
          this.model.password = this.clientNewPassword;
          this.clientPasswordEdited = false;
          this.onSave();
        } else {
          this.toasterNotificationService.showWarning($localize`:@@: New password does not match confirmation password.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
        }
      } else {
        this.toasterNotificationService.showWarning($localize`:@@: Invalid old password.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
      }
    } else {
      this.onSave();
    }
  }

  updateAdminControl() {
    this.adminPasswordEdited = true;
    if ((this.adminNewPassword != undefined && this.adminNewPassword != "")) {
      if (this.adminNewPassword != undefined && this.adminNewPassword.length > 5) {
        this.model.password = this.adminNewPassword;
        this.adminPasswordEdited = false;
        this.onSave();
      }
    } else {
      this.onSave();
    }
  }

  signaturePNGTransform() {
    if (this.model && this.model.signature) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.model.signature}`);
    }
    return GlobalComponent.defaultNoSignatureImage;
  }

  initialPNGTransform() {
    if (this.model && this.model.initials) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${this.model.initials}`);
    }
    return GlobalComponent.defaultNoSignatureImage;
  }


  sendClientPasswordReset() {
    if (this.model.email != undefined && this.model.email != '' && (this.model.email.match(this.emailPattern) != null)) {
      Swal.fire({
        title: $localize`:@@:Are you sure you want to reset the clients the password?`,
        text: $localize`:@@:The client will receive an email with the new password at: ${this.model.email} `,
        icon: 'question',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        showCancelButton: true,
        confirmButtonColor: 'rgb(3, 142, 220)',
        cancelButtonColor: 'rgb(243, 78, 78)',
        confirmButtonText: $localize`:@@:Send Email`,
        cancelButtonText: $localize`:@@:Cancel`
      }).then(result => {
        if (result && result.isConfirmed) {
          this.myFileApiService.getBusinessUnitForCurrentUser().subscribe(result => {
            if (result) {
              this.authMyFileService.forgotPassword(this.model.email, LoginType.Client, result.tenantId)
                .subscribe((result) => {
                  if (result == true) {
                    this.toasterNotificationService.showSuccess("Password reset sent.", "Password Reset");
                  }
                });
            }
          })
        }
      });
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'Please enter a valid Email',
        color: 'var(--vz-body-color)',
        background: 'var(--vz-body-bg)',
        confirmButtonColor: '#299cdb',
      });
    }
  }
}